import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed } from 'vue';
import ProductCardLens from './ProductCardLens.vue';
import ProductCardLensCare from './ProductCardLensCare.vue';
import ProductCardMultiPower from './ProductCardMultiPower.vue';
import type { LensProperty, ProductImage, Variant, HighlightBgColor } from '@/models/webshop.model';
import { PRODUCT_CATEGORY_LENS_CARE } from '@/constants/webshop';
import BaseSurface from '@/lib/components/Surface/BaseSurface.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
    mlsId: {},
    productCategory: {},
    productCategorySlug: {},
    productCategoryDisplayName: {},
    title: {},
    image: {},
    highlightText: {},
    highlightColor: {},
    lensProperties: {},
    variants: {},
    lensCode: {},
    powerSelectionMode: {},
    dataDusk: {}
  },
  setup(__props: any) {

const props = __props;

const isMultiPowerMode = computed(() => props.powerSelectionMode === 'multi');
const isLensCare = computed(() => props.productCategory === PRODUCT_CATEGORY_LENS_CARE);
const cardDusk = computed(() => props.dataDusk || 'product-card-id');
const safeLensProperties = computed(() => props.lensProperties ?? []);
const safeVariants = computed(() => props.variants ?? []);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseSurface, {
    class: "product-card-item",
    "data-dusk": "product-card"
  }, {
    default: _withCtx(() => [
      (isMultiPowerMode.value)
        ? (_openBlock(), _createBlock(ProductCardMultiPower, {
            key: 0,
            "mls-id": _ctx.mlsId,
            "product-category": _ctx.productCategory,
            "product-category-slug": _ctx.productCategorySlug,
            "product-category-display-name": _ctx.productCategoryDisplayName,
            title: _ctx.title,
            image: _ctx.image,
            "lens-properties": safeLensProperties.value,
            variants: safeVariants.value,
            "lens-code": _ctx.lensCode,
            "data-dusk": cardDusk.value,
            "highlight-text": _ctx.highlightText,
            "highlight-color": _ctx.highlightColor
          }, null, 8, ["mls-id", "product-category", "product-category-slug", "product-category-display-name", "title", "image", "lens-properties", "variants", "lens-code", "data-dusk", "highlight-text", "highlight-color"]))
        : (isLensCare.value)
          ? (_openBlock(), _createBlock(ProductCardLensCare, {
              key: 1,
              "mls-id": _ctx.mlsId,
              "product-category": _ctx.productCategory,
              "product-category-slug": _ctx.productCategorySlug,
              "product-category-display-name": _ctx.productCategoryDisplayName,
              title: _ctx.title,
              image: _ctx.image,
              "lens-properties": safeLensProperties.value,
              variants: safeVariants.value,
              "data-dusk": cardDusk.value,
              "highlight-text": _ctx.highlightText,
              "highlight-color": _ctx.highlightColor
            }, null, 8, ["mls-id", "product-category", "product-category-slug", "product-category-display-name", "title", "image", "lens-properties", "variants", "data-dusk", "highlight-text", "highlight-color"]))
          : (_openBlock(), _createBlock(ProductCardLens, {
              key: 2,
              "mls-id": _ctx.mlsId,
              "product-category": _ctx.productCategory,
              "product-category-slug": _ctx.productCategorySlug,
              "product-category-display-name": _ctx.productCategoryDisplayName,
              title: _ctx.title,
              image: _ctx.image,
              "lens-properties": safeLensProperties.value,
              variants: safeVariants.value,
              "lens-code": _ctx.lensCode,
              "data-dusk": cardDusk.value,
              "highlight-text": _ctx.highlightText,
              "highlight-color": _ctx.highlightColor
            }, null, 8, ["mls-id", "product-category", "product-category-slug", "product-category-display-name", "title", "image", "lens-properties", "variants", "lens-code", "data-dusk", "highlight-text", "highlight-color"]))
    ]),
    _: 1
  }))
}
}

})